<template>
  <el-dialog class="common-dialog" :title="title" :visible="visible" center :modal-append-to-body="false" :close-on-click-modal="false" @close="dialogClose" :append-to-body="appendToBody">
    <!-- <span v-text="dialogOptions.tip"></span> -->
    <slot name="dialogContent"></slot>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" @click="clickCancel" size="small">{{ dialogOptions.cancelText || '取 消' }}</el-button>
      <el-button type="primary" @click="clickConfirm" size="small">{{ dialogOptions.confirmText || '确 定' }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'subAccountCommonDialog',
  data() {
    return {}
  },
  props: {
    visible: Boolean,
    title: {
      default: '提示',
      type: String
    },
    dialogOptions: {
      type: Object,
      default: function() {
        return {
          type: '',
          title: '提示',
          tip: '',
          cancelText: '取 消',
          confirmText: '确 定'
        }
      }
    },
    appendToBody: { type: Boolean, default: false }
  },
  methods: {
    dialogClose() {
      this.$emit('clickCancel')
    },
    clickCancel() {
      this.$emit('clickCancel')
    },
    clickConfirm() {
      this.$emit('clickConfirm')
    }
  }
}
</script>
